
import Header from '../../components/feature/Header';

export default function Projects() {
  const projects = [
    {
      title: "屏東縣鹽埔鄉振興國民小學光明路通學步道改善工程",
      category: "教育設施",
      description: "改善學童通學安全，提升步道品質與安全性",
      image: "https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/66b10eaf865c27dca9c5f5707fede9fc.jpeg"
    },
    {
      title: "霧台樟樹林步道第二期工程",
      category: "環境改善",
      description: "原住民部落步道建設，結合自然環境與文化特色",
      image: "https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/31f4afaca4b7e3009b10452612730fc6.jpeg"
    },
    {
      title: "好茶部落文廣場改善工程",
      category: "文化設施",
      description: "部落文化廣場整建，保存原住民文化傳統",
      image: "https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/ff55d483a2f72d6875c096edca6e5a2f.jpeg"
    },
    {
      title: "屏東縣立里港國民中學風雨球場新建工程",
      category: "體育設施",
      description: "新建室內體育場館，提供學生全天候運動空間",
      image: "https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/1ae4e0dfdcdaa258075bd2a15f36098e.jpeg"
    },
    {
      title: "屏東縣立高泰國民中學風雨教室屋頂浪板更新工程",
      category: "建築維修",
      description: "教室屋頂翻新工程，改善教學環境品質",
      image: "https://static.readdy.ai/image/e7430320e3bc3f9244a461515e2266b3/f2cc551dcfbd6fbec9b2086af7d84a24.jpeg"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">工程實績</h1>
            <div className="w-24 h-1 bg-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600 text-lg">歷年完成的優質工程項目</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="flex items-center mb-2">
                    <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium">
                      {project.category}
                    </span>
                  </div>
                  <h3 className="text-lg font-bold text-gray-800 mb-3 leading-tight">
                    {project.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-16">
            <div className="bg-white rounded-lg shadow-lg p-8">
              <div className="text-center mb-8">
                <h2 className="text-2xl font-bold text-gray-800 mb-4">工程成果統計</h2>
                <p className="text-gray-600">多年來累積的豐富經驗與優良績效</p>
              </div>
              
              <div className="grid md:grid-cols-4 gap-6">
                <div className="text-center">
                  <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-building-line text-2xl text-blue-600"></i>
                  </div>
                  <div className="text-2xl font-bold text-gray-800 mb-1">20+</div>
                  <div className="text-gray-600 text-sm">年經驗</div>
                </div>
                
                <div className="text-center">
                  <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-checkbox-circle-line text-2xl text-green-600"></i>
                  </div>
                  <div className="text-2xl font-bold text-gray-800 mb-1">100+</div>
                  <div className="text-gray-600 text-sm">完成項目</div>
                </div>
                
                <div className="text-center">
                  <div className="bg-yellow-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-award-line text-2xl text-yellow-600"></i>
                  </div>
                  <div className="text-2xl font-bold text-gray-800 mb-1">98%</div>
                  <div className="text-gray-600 text-sm">客戶滿意度</div>
                </div>
                
                <div className="text-center">
                  <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3">
                    <i className="ri-team-line text-2xl text-purple-600"></i>
                  </div>
                  <div className="text-2xl font-bold text-gray-800 mb-1">50+</div>
                  <div className="text-gray-600 text-sm">專業團隊</div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center">
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg p-8">
              <h2 className="text-2xl font-bold mb-4">讓我們為您打造下一個優質工程</h2>
              <p className="text-blue-100 mb-6">憑藉豐富經驗與專業技術，為您提供最優質的工程服務</p>
              <a 
                href="mailto:nero.nero@msa.hinet.net" 
                className="inline-flex items-center bg-white text-blue-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line mr-2"></i>
                討論您的工程需求
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
